(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gww-daily-designer"] && !Shopify.designMode) return;
  try {
    (() => {
  function refresh() {
    document.querySelectorAll('[data-gww-daily]').forEach(root => {
      const data = JSON.parse(root.querySelector('[data-gww-roster]').textContent);
      const day = Math.floor((Date.now() + 19800000) / 86400000);
      const index = ((day - 20746) % data.names.length + data.names.length) % data.names.length;
      if (Number(root.dataset.index) === index) return;
      const image = root.querySelector('img');
      const url = data.images[index];
      root.querySelector('a').setAttribute('href', data.urls[index]);
      root.querySelector('h2').textContent = data.names[index];
      image.alt = data.names[index];
      image.srcset = [750,1200,1800].map(w => url + '&width=' + w + ' ' + w + 'w').join(', ');
      image.src = url + '&width=1800';
      root.dataset.index = index;
    });
  }
  refresh();
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); });
  setInterval(refresh, 60000);
})();
  } catch(e) { console.error(e); }
})();

})();
